import productionInProcess from './productionInProcess'

const modules = {
  productionInProcess
}

export default {
  namespaced: true,
  modules
}
